import { forwardRef } from "react";

import { cva, type VariantProps } from "class-variance-authority";

import * as Separator from "@radix-ui/react-separator";

import { cn } from "..";

const dividerVariants = cva("bg-primary-darker-gray", {
  variants: {
    orientation: {
      horizontal: "my-4 mx-0 h-0.5 w-full",
      vertical: "my-0 mx-4 w-0.5 h-full",
    },
  },
  defaultVariants: {
    orientation: "horizontal",
  },
});

type DividerProps = Separator.SeparatorProps & VariantProps<typeof dividerVariants>;

const Divider = forwardRef<HTMLHRElement, DividerProps>(
  ({ className, orientation = "horizontal", ...props }, forwardedRef) => (
    <Separator.Root {...props} ref={forwardedRef} className={cn(dividerVariants({ orientation, className }))} />
  ),
);

Divider.displayName = "Divider";

export { Divider };
export type { DividerProps };
